import React, { useContext } from 'react';
import AppContext from './Context';
import './Multistepdesignstyles.css';
import WhatsNext from '../../components/WhatsNext';
import { useUserContext } from '../../context/user_context';
import { useHistory } from 'react-router-dom';

const Finish = () => {
    const { isLoggedIn } = useUserContext();
    const myContext = useContext(AppContext);
    const updateContext = myContext.personalDetails; // Correcting this to personalDetails context
    const password = myContext?.password ?? "Not Available";
    const history = useHistory();
    
    const subscriberName = updateContext.subscriberName; // Subscriber name

    const handleBackButtonClick = () => {
        history.push('/home'); // Redirect to the home page
    };

    return (
        <div className="container">
            <p>New Subscriber <strong>{subscriberName}</strong> has been created successfully.</p>
            <img
                className="done"
                src="https://www.svgrepo.com/show/13650/success.svg"
                alt="success"
            />
            <p>Thank you for providing your details.</p>
            <p>Your temporary password is: <strong>{password}</strong></p>
            {isLoggedIn && (
                <button className="back-button" onClick={handleBackButtonClick}>
                    Back to Home
                </button>
            )}
            <WhatsNext subscriberName={subscriberName} />
        </div>
    );
};

export default Finish;
